import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useUserUUID } from '@annunciate/core';
export const useProgress = (contentId) => {
    const uuid = useUserUUID();
    const queryKey = [`progress`, { contentId, uuid }];
    const client = useQueryClient();
    return useQuery({
        queryKey,
        queryFn: () => {
            if (!contentId)
                return null;
            return getProgress({ client, uuid, contentId });
        },
    });
};
export const getProgress = ({ client, uuid, contentId, }) => {
    const cacheKey = [`progress`, { contentId, uuid }];
    return (client.getQueryData(cacheKey) ||
        {
            __typename: "Progress",
            uuid,
            contentId,
            position: null,
        });
};
//# sourceMappingURL=useProgress.js.map